<template>
  <div class="content">
    <img class="header" src="../../assets/background-0309.jpg">
    <div class="body">
      <div class="con con1">
        <div v-for="(group, index) in todayData" :key="index" class="group-con">
          <div class="list">
            <div :class="`paiming ${'paiming' + index }`">{{ index + 1 }}</div>
            <div class="info-con">
              <div class="info-con-left">
                <div class="touxiang-con">
                  <div class="touxiang">
                    <img :src="group.img1" class="touxiang" />
                  </div>
                  <div class="touxiang">
                    <img :src="group.img2" class="touxiang" />
                  </div>
                </div>
                <div class="name">
                  {{ group.groupName }}
                </div>
              </div>
              <div class="num">
                {{ parseInt(group.groupTotal) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con con2">
        <div v-for="(group, index) in todayData2" :key="index" class="group-con">
          <div class="list">
            <div :class="`paiming ${'paiming' + index }`">{{ index + 1 }}</div>
            <div class="info-con">
              <div class="info-con-left">
                <div class="touxiang-con">
                  <div class="touxiang">
                    <img :src="group.img1" class="touxiang" />
                  </div>
                  <div class="touxiang">
                    <img :src="group.img2" class="touxiang" />
                  </div>
                </div>
                <div class="name">
                  {{ group.groupName }}
                </div>
              </div>
              <div class="num">
                {{ parseInt(group.groupTotal) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con con3">
        <div v-for="(group, index) in currentMonthData" :key="index" class="group-con">
          <div class="list">
            <div :class="`paiming ${'paiming' + index }`">{{ index + 1 }}</div>
            <div class="info-con">
              <div class="info-con-left">
                <div class="touxiang-con">
                  <div class="touxiang">
                    <img :src="group.img1" class="touxiang" />
                  </div>
                  <div class="touxiang">
                    <img :src="group.img2" class="touxiang" />
                  </div>
                </div>
                <div class="name">
                  {{ group.groupName }}
                </div>
              </div>
              <div class="num">
                {{ parseInt(group.groupTotal) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con con4">
        <div v-for="(group, index) in currentMonthData2" :key="index" class="group-con">
          <div class="list">
            <div :class="`paiming ${'paiming' + index }`">{{ index + 1 }}</div>
            <div class="info-con">
              <div class="info-con-left">
                <div class="touxiang-con">
                  <div class="touxiang">
                    <img :src="group.img1" class="touxiang" />
                  </div>
                  <div class="touxiang">
                    <img :src="group.img2" class="touxiang" />
                  </div>
                </div>
                <div class="name">
                  {{ group.groupName }}
                </div>
              </div>
              <div class="num">
                {{ parseInt(group.groupTotal) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'
import userList from './data'
import axios from '../axios-instance'

export default {
  name: 'page260309',
  data () {
    return {
      todayData: [],
      todayData2: [],
      currentMonthData: [],
      currentMonthData2: [],
      groupList1: [
        {
          name1: '辛洋',
          id1: 23,
          name2: '雅儿',
          id2: 7,
          groupName: '辛马拉雅'
        },
        {
          name1: '天宇',
          id1: 25,
          name2: '堇一',
          id2: 35,
          groupName: '宇你相一'
        },
        {
          name1: '晓亮',
          id1: 29,
          name2: '琪琪',
          id2: 22,
          groupName: '晓猪佩琪'
        },
        {
          name1: '嘉文',
          id1: 3,
          name2: '甜妹',
          id2: 32,
          groupName: '甜蜜嘉倍'
        },
        {
          name1: '天启',
          id1: 5,
          name2: '小妮',
          id2: 44,
          groupName: '与妮一启'
        },
        {
          name1: '顾洋',
          id1: 53,
          name2: '温柔曦',
          id2: 13,
          groupName: '曦气洋洋'
        },
        {
          name1: '一泽',
          id1: 27,
          name2: '菲宝',
          id2: 12,
          groupName: '一菲冲天'
        },
        {
          name1: '志虎',
          id1: 4,
          name2: '小美',
          id2: 1,
          groupName: '幸虎美满'
        },
        {
          name1: '柏秋',
          id1: 30,
          name2: '依玥',
          id2: 10,
          groupName: '柏里挑依'
        },
        {
          name1: '太阳',
          id1: 17,
          name2: '婉儿',
          id2: 20,
          groupName: '阳名立婉'
        }
      ],
      groupList2: [
        {
          name1: '云朝',
          id1: 62,
          name2: '冰冰',
          id2: 14,
          groupName: '朝冰买马'
        },
        {
          name1: '李冠一',
          id1: 91,
          name2: '红妹',
          id2: 11,
          groupName: '一炮而红'
        },
        {
          name1: '丁楠',
          id1: 88,
          name2: '虎牙',
          id2: 54,
          groupName: '楠牙知己'
        },
        {
          name1: '王子凡',
          id1: 68,
          name2: '萌宝',
          id2: 16,
          groupName: '凡心萌动'
        },
        {
          name1: '陈举举',
          id1: 40,
          name2: '心炫',
          id2: 83,
          groupName: '陈心如意'
        },
        {
          name1: '伯乐意',
          id1: 89,
          name2: '兮妹',
          id2: 19,
          groupName: '兮伯利亚'
        },
        {
          name1: '子画',
          id1: 50,
          name2: '圆妹',
          id2: 79,
          groupName: '画好月圆'
        },
        {
          name1: '笑笑',
          id1: 26,
          name2: '扛刀',
          id2: 34,
          groupName: '笑里藏刀'
        },
        {
          name1: '李权',
          id1: 87,
          name2: '雪儿',
          id2: 9,
          groupName: '护雪周权'
        },
        {
          name1: '浩森',
          id1: 69,
          name2: '胡雪莉',
          id2: 31,
          groupName: '浩喜欢莉'
        },
        {
          name1: '冠冠',
          id1: 52,
          name2: '娜娜',
          id2: 15,
          groupName: '必定娜冠'
        },
        {
          name1: '摆摆',
          id1: 90,
          name2: '雪雪',
          id2: 18,
          groupName: '洁摆如雪'
        },
        {
          name1: '可心',
          id1: 24,
          name2: '小欣',
          id2: 39,
          groupName: '欣心相印'
        }
      ],
      userList
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.getAllData()
    }, 20000)
    this.getAllData(true)
    // this.getAllUserInfo()
    this.groupList1 = this.groupList1.map((item) => {
      item.img1 = this.userList.find(ele => ele.id === item.id1).img
      item.img2 = this.userList.find(ele => ele.id === item.id2).img
      return item
    })
    this.groupList2 = this.groupList2.map((item) => {
      item.img1 = this.userList.find(ele => ele.id === item.id1).img
      item.img2 = this.userList.find(ele => ele.id === item.id2).img
      return item
    })
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    getAllUserInfo () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/getAll`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
        .then((res) => {
          // console.log('所有主播数据：', res.data)
          if (res.status === 200 && res.data && res.data.data && res.data.data.length) {
            this.userList = res.data.data
          }
        })
    },
    getTodayData () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/heat/today`,
        method: 'post',
        data: {
    "gmvList": [7,19,9,11,20],
    "giftList": [23,25,35,29,62,3,32,88,54,5,44,68,53,40,83,27,89,50,79,87,26,34,68,31,52,4,30,90,24,39,91,17],
    "gmvAndGiftList": [22,14,16,13,12,1,15,10,18],
    "gmvCoefficient": 1,
        "giftCoefficient": 5,
},
        headers: {
          'tenant-id': 1
        }
      })
    },
    getCurrentMonthData () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/heat/currentMonth`,
        method: 'post',
        data: {
    "gmvList": [7,19,9,11,20],
    "giftList": [23,25,35,29,62,3,32,88,54,5,44,68,53,40,83,27,89,50,79,87,26,34,68,31,52,4,30,90,24,39,91,17],
    "gmvAndGiftList": [22,14,16,13,12,1,15,10,18],
    "gmvCoefficient": 1,
        "giftCoefficient": 5,
},
        headers: {
          'tenant-id': 1
        }
      })
    },
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime260309')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 10000) {
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData260309') || '{}'), isFirst)
        this.loaded1(JSON.parse(window.localStorage.getItem('cacheMonthData260309') || '{}'), isFirst)
        return false
      }
      this.getTodayData().then((res) => {
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime260309', moment().valueOf())
          window.localStorage.setItem('cacheData260309', JSON.stringify(res.data.data))
          this.loaded(res.data.data, isFirst)
        } else {
          this.loaded(JSON.parse(window.localStorage.getItem('cacheData260309') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData260309') || '{}'), isFirst)
      })
      this.getCurrentMonthData().then((res) => {
        if (res && res.data.code === 0) {
          window.localStorage.setItem('cacheMonthData260309', JSON.stringify(res.data.data))
          this.loaded1(res.data.data, isFirst)
        } else {
          this.loaded1(JSON.parse(window.localStorage.getItem('cacheMonthData260309') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded1(JSON.parse(window.localStorage.getItem('cacheMonthData260309') || '{}'), isFirst)
      })
    },
    loaded (data, isFirst) {
      let res = []
      let res2 = []
      this.groupList1.forEach((item, i) => {
        if (isFirst) {
          item.img1 = this.userList.find(ele => ele.id === item.id1).img
          item.img2 = this.userList.find(ele => ele.id === item.id2).img
        }
        item.groupTotal = parseInt((data[item.id1] || 0) + (data[item.id2] || 0))
        res.push(item)
      })
      this.groupList2.forEach((item, i) => {
        if (isFirst) {
          item.img1 = this.userList.find(ele => ele.id === item.id1).img
          item.img2 = this.userList.find(ele => ele.id === item.id2).img
        }
        item.groupTotal = parseInt((data[item.id1] || 0) + (data[item.id2] || 0))
        res2.push(item)
      })
      if (!res.length) {
        return false
      }
      res.sort((a, b) => b.groupTotal - a.groupTotal)
      res2.sort((a, b) => b.groupTotal - a.groupTotal)
      if (isFirst) {
        this.todayData = cloneDeep(res).map((item, i) => {
          item.groupTotal = 0
          return item
        })
        this.todayData2 = cloneDeep(res2).map((item, i) => {
          item.groupTotal = 0
          return item
        })
      }
      this.dealData(this.todayData, cloneDeep(res), isFirst)
      this.dealData2(this.todayData2, cloneDeep(res2), isFirst)
    },
    dealData (data, newData, isFirst) {
      if (data && data.length) {
        newData.forEach((item, index) => {
          item.newNumber = item.groupTotal
          item.groupTotal = data.find(ele => ele.id1 === item.id1).groupTotal
          item.numOnce = this.getOnce(item.newNumber, item.groupTotal)
        })
      }
      this.todayData = newData
      this.intervalFn(isFirst)
    },
    intervalFn (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.todayData = this.todayData.map(item => {
          if (item.groupTotal !== item.newNumber) {
            item.groupTotal = item.groupTotal + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          this.todayData = this.todayData.map(item => {
            item.groupTotal = item.newNumber
            return item
          })
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    dealData2 (data, newData, isFirst) {
      if (data && data.length) {
        newData.forEach((item, index) => {
          item.newNumber = item.groupTotal
          item.groupTotal = data.find(ele => ele.id1 === item.id1).groupTotal
          item.numOnce = this.getOnce(item.newNumber, item.groupTotal)
        })
      }
      this.todayData2 = newData
      this.intervalFn2(isFirst)
    },
    intervalFn2 (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.todayData2 = this.todayData2.map(item => {
          if (item.groupTotal !== item.newNumber) {
            item.groupTotal = item.groupTotal + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          this.todayData2 = this.todayData2.map(item => {
            item.groupTotal = item.newNumber
            return item
          })
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    loaded1 (data, isFirst) {
      let res = []
      let res2 = []
      this.groupList1.forEach((item, i) => {
        item.groupTotal = parseInt((data[item.id1] || 0) + (data[item.id2] || 0))
        res.push(item)
      })
      this.groupList2.forEach((item, i) => {
        item.groupTotal = parseInt((data[item.id1] || 0) + (data[item.id2] || 0))
        res2.push(item)
      })
      if (!res.length) {
        return false
      }
      res.sort((a, b) => b.groupTotal - a.groupTotal)
      res2.sort((a, b) => b.groupTotal - a.groupTotal)
      if (isFirst) {
        this.currentMonthData = cloneDeep(res).map((item, i) => {
          item.groupTotal = 0
          return item
        })
        this.currentMonthData2 = cloneDeep(res2).map((item, i) => {
          item.groupTotal = 0
          return item
        })
      }
      this.dealData3(this.currentMonthData, cloneDeep(res), isFirst)
      this.dealData4(this.currentMonthData2, cloneDeep(res2), isFirst)
    },
    dealData3 (data, newData, isFirst) {
      if (data && data.length) {
        newData.forEach((item, index) => {
          item.newNumber = item.groupTotal
          item.groupTotal = data.find(ele => ele.id1 === item.id1).groupTotal
          item.numOnce = this.getOnce(item.newNumber, item.groupTotal)
        })
      }
      this.currentMonthData = newData
      this.intervalFn3(isFirst)
    },
    intervalFn3 (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.currentMonthData = this.currentMonthData.map(item => {
          if (item.groupTotal !== item.newNumber) {
            item.groupTotal = item.groupTotal + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          this.currentMonthData = this.currentMonthData.map(item => {
            item.groupTotal = item.newNumber
            return item
          })
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    dealData4 (data, newData, isFirst) {
      if (data && data.length) {
        newData.forEach((item, index) => {
          item.newNumber = item.groupTotal
          item.groupTotal = data.find(ele => ele.id1 === item.id1).groupTotal
          item.numOnce = this.getOnce(item.newNumber, item.groupTotal)
        })
      }
      this.currentMonthData2 = newData
      this.intervalFn4(isFirst)
    },
    intervalFn4 (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.currentMonthData2 = this.currentMonthData2.map(item => {
          if (item.groupTotal !== item.newNumber) {
            item.groupTotal = item.groupTotal + item.numOnce
          }
          return item
        })
        if (i >= 40) {
          this.currentMonthData2 = this.currentMonthData2.map(item => {
            item.groupTotal = item.newNumber
            return item
          })
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    getOnce (n, o) {
      // 分多少次处理
      if (n !== o) {
        return (n - o) / 40
      }
      return 0
    }
  }
}
</script>

<style scoped>
.content {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-size: 1.6vh;
  color: #fff;
  font-family: 黑体;
  .header {
    width: 100%;
    height: 100vh;
    display: block;
  }
  .body {
    position: absolute;
    top: 46%;
    width: 100%;
    height: 46vh;
  }
  .con {
    position: absolute;
    top: 0;
    height: 100%;
    width: 20%;
    padding: 1vh;
  }
}
.con1 {
  left: 3.8%;
}
.con2 {
  left: 27.6%;
}
.con3 {
  left: 51.45%;
}
.con4 {
  left: 75.45%;
}
.con1, .con3 {
  .group-con {
    height: 4.5vh;
  }
  .list {
    border-radius: 1.2vh 1.6vh 1.6vh 1.2vh;
  }
  .paiming {
    width: 3.22vh;
    font-size: 2.8vh;
  }
  .info-con {
    width: calc(100% - 3.72vh)
  }
}
.con2, .con4 {
  .group-con {
    height: 3.45vh;
  }
  .list {
    border-radius: 1.23vh;
  }
  .paiming {
    width: 2.47vh;
    font-size: 2vh;
  }
  .info-con {
    width: calc(100% - 2.97vh)
  }
}
.list {
  display : flex;
  justify-content: space-between;
  height: 70%;
  width: 100%;
  /* background: linear-gradient(90deg, #fff, #83c9e3); */
}
.info-con {
  display : flex;
  align-items: center;
  background: #ffb1d8;
  border: 1px solid #916a7d;
  border-radius: 0.6vh;
  box-sizing: border-box;
  justify-content: space-between;
}
.paiming {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: linear-gradient(90deg, #52842d, #9ac059); */
  background: #c0e5ff;
  color: #fff;
  margin-right: 0.5vh;
  border: 1px solid #916a7d;
  border-radius: 0.6vh;
  box-sizing: border-box;
  font-weight: bold;
}
.touxiang-con {
  display: flex;
  margin: 0 1vh 0 0.5vh;
  height: 100%;
  align-items: center;
  .touxiang {
    height: 80%;
  }
  .touxiang > img {
    width: auto;
    height: 100%;
    border-radius: 50%;
    /* border: 1px solid #83c9e3; */
    overflow: hidden;
  }
}
.name {
  font-weight: bold;
}
.info-con-left {
  display : flex;
  align-items: center;
  height: 100%;
}
.num {
  text-align: right;
  /* display: flex;
  align-items: center; */
  margin-right: 1.5vh;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/page260309/page260309.vue